module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/administrative/marika-tarczynska-93936b69e814f2c66a8e9aba80ff84a8.webp";